// Honeybadger is for faults we can act on. A shopper mistyping a postcode or a
// bank refusing a card is neither broken nor ours to fix - it is already
// surfaced in the UI, and filing it as a fault buries the real errors. The
// coupon form is the precedent: an invalid code is tracked as a funnel event
// ("Coupon / Gift Card Denied"), never as a fault.

// Stripe words every card_error as advice to the shopper - "Your card has
// insufficient funds", "Your card was declined", "Your card has expired". The
// SDK re-throws them as plain Errors, so the message is the only signal left.
var SHOPPER_CARD_ERROR_RE = /^your card\b/i;

// The SDK's wording when a stored instrument fails re-authentication. Matched as
// its own exact phrase rather than by widening the rule above - it tells the
// shopper to pick another method, and a looser pattern would start swallowing
// genuine 3DS integration failures.
var SHOPPER_AUTH_ERROR_RE = /^we are unable to authenticate your payment method\b/i;

// The wallet path's wording for a plain decline. Apple and Google Pay surface it
// as OrderFinalizationNotCompletedError after the sheet closes, so it carries
// neither a card_error type nor a decline_code, and "your card" never matches.
var SHOPPER_DECLINE_RE = /^your payment was declined\b/i;

// Refusals caused by what the shopper entered, or by a cart that has moved on.
// Deliberately narrow: 401/403 mean our credentials are wrong and 429 means we
// are being throttled, so those stay reportable, as does anything 5xx. The
// create-order and process-payment 422s are held back too - they are just as
// likely to be a payload of ours as anything the shopper did, and the upstream
// response body we now capture should settle which.
var SHOPPER_RESOLVABLE_STATUS = new Set([400, 402, 409, 410]);

// Thrown by the SDK once a checkout has expired, been cleared, or already
// become an order. Nothing is broken - the shopper needs a fresh cart.
var CHECKOUT_GONE = {
  name: "CheckoutNotAvailableError",
  type: "checkout_not_available"
};
var errorAs = function errorAs(error) {
  return error !== null && error !== void 0 ? error : {};
};
var isPaymentRefused = function isPaymentRefused(error) {
  var _errorAs = errorAs(error),
    type = _errorAs.type,
    declineCode = _errorAs.decline_code,
    message = _errorAs.message;
  var text = message !== null && message !== void 0 ? message : "";
  return type === "card_error" || !!declineCode || SHOPPER_CARD_ERROR_RE.test(text) || SHOPPER_AUTH_ERROR_RE.test(text) || SHOPPER_DECLINE_RE.test(text);
};

// axios hangs the status off the response; SDK errors carry it directly.
export var statusOf = function statusOf(error) {
  var _response$status;
  var _errorAs2 = errorAs(error),
    status = _errorAs2.status,
    response = _errorAs2.response;
  return (_response$status = response === null || response === void 0 ? void 0 : response.status) !== null && _response$status !== void 0 ? _response$status : typeof status === "number" ? status : undefined;
};
export var isShopperResolvable = function isShopperResolvable(error) {
  if (isPaymentRefused(error)) return true;
  var _errorAs3 = errorAs(error),
    name = _errorAs3.name,
    type = _errorAs3.type;
  if (name === CHECKOUT_GONE.name || type === CHECKOUT_GONE.type) return true;
  var status = statusOf(error);
  return status !== undefined && SHOPPER_RESOLVABLE_STATUS.has(status);
};